class ReturnFlow extends HTMLElement {
  constructor() {
    super();
    this.activeReason = null;
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('change', this.onChange.bind(this));
  }

  onClick(event) {
    const reasonBtn = event.target.closest('[data-return-reason]');
    if (reasonBtn && this.contains(reasonBtn)) {
      event.preventDefault();
      this.toggleReason(reasonBtn.dataset.returnReason);
    }
  }

  onChange(event) {
    const radio = event.target.closest('[data-return-sub-option]');
    if (radio && this.contains(radio) && radio.checked) {
      this.showPanel(radio);
    }
  }

  toggleReason(reasonId) {
    const willClose = this.activeReason === reasonId;

    this.querySelectorAll('[data-return-reason]').forEach((btn) => {
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-expanded', 'false');
    });

    this.querySelectorAll('[data-return-expand]').forEach((expand) => {
      expand.hidden = true;
    });

    this.querySelectorAll('[data-return-panel]').forEach((panel) => {
      panel.hidden = true;
    });

    this.querySelectorAll('[data-return-sub-option]').forEach((radio) => {
      radio.checked = false;
    });

    if (willClose) {
      this.activeReason = null;
      return;
    }

    const btn = this.querySelector(`[data-return-reason="${reasonId}"]`);
    const expand = this.querySelector(`[data-return-expand="${reasonId}"]`);

    if (btn) {
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-expanded', 'true');
    }
    if (expand) {
      expand.hidden = false;
    }

    this.activeReason = reasonId;
  }

  showPanel(radio) {
    const expand = radio.closest('[data-return-expand]');
    if (!expand) return;

    const subOptionId = radio.dataset.returnSubOption;

    expand.querySelectorAll('[data-return-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.returnPanel !== subOptionId;
    });

    const panel = expand.querySelector(`[data-return-panel="${subOptionId}"]`);
    if (panel) {
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
}

if (!customElements.get('return-flow')) {
  customElements.define('return-flow', ReturnFlow);
}
